import { Route } from '@angular/router';
import { AuthGuard } from './../../_guards/auth.guard';
import { ActiveSupplierResolver } from './../Suppliers/Services/supplier.resolver.service';
import {
  ReceptionControlListResolver,
  ReceptionControlEditResolver,
  GoodsTypeByBusinessResolver,
  ReceptionControlDocumentResolver
} from './services/reception-control.resolver.service';
import { ReceptionControlFormComponent } from './components/reception-control-form.component';
import { ReceptionControlListComponent } from './components/reception-control-list.component';
import { ReceptionControlComponent } from './reception-control.component';

export const ReceptionControlRoutes: Route[] = [
  {
    path: 'reception-control',
    component: ReceptionControlComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'list',
        component: ReceptionControlListComponent,
        canActivate: [AuthGuard],
        resolve: {
          list: ReceptionControlListResolver,
          suppliers: ActiveSupplierResolver,
          goodsType: GoodsTypeByBusinessResolver
        }
      },
      {
        path: 'edit/:rid',
        component: ReceptionControlFormComponent,
        canActivate: [AuthGuard],
        resolve: {
          reception: ReceptionControlEditResolver,
          suppliers: ActiveSupplierResolver,
          goodsType: GoodsTypeByBusinessResolver,
          docList: ReceptionControlDocumentResolver
        }
      }
    ]
  }
];
